var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "b-notification",
        {
          attrs: {
            type: "is-warning is-light",
            "aria-close-label": "Close notification",
            closable: false,
            role: "alert",
          },
        },
        [
          _c("p", [_vm._v(_vm._s(_vm.$t('msg["email is not verified"]')))]),
          _vm._v(" "),
          _c("p", [
            _c(
              "a",
              {
                attrs: { click: "u-clickable" },
                on: { click: _vm.sendVerificationMail },
              },
              [_vm._v(_vm._s(_vm.$t('msg["Resend verification email"]')))]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }